var rbush = require('rbush');

function tree () {
  return rbush(7, ['.minLng', '.minLat', '.maxLng', '.maxLat']);
}

module.exports = tree;



//////////////////
// WEBPACK FOOTER
// ./node_modules/which-country/lib/base-tree.js
// module id = 259
// module chunks = 0